export const business = {
  name: "Jal RO System",
  phone: "+91 99587 89599",
  phoneHref: "tel:+919958789599",
  whatsapp: "https://wa.me/919958789599",
  email: "info@jalro.in",
  emailHref: "mailto:info@jalro.in",
  address: "Delhi NCR, India",
  logo: "/assets/img/jal-ro/jlogo.png",
  formAction: "/send-enquiry.php",
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Products", path: "/products" },
  { label: "Service Areas", path: "/service-areas" },
  { label: "FAQ", path: "/faq" },
  { label: "Careers", path: "/careers" },
  { label: "Contact Us", path: "/contact" },
];

export const heroSlides = [
  {
    title: "RO Water Purifier Service in Delhi NCR",
    subtitle: "Same day repair, installation, AMC and filter replacement by expert RO technicians.",
    image: "/assets/img/jal-ro/palak-slide-1.jpg",
  },
  {
    title: "Domestic RO Repair at Your Doorstep",
    subtitle: "Low flow, bad taste, leakage, pump fault, membrane issue and TDS problem solved fast.",
    image: "/assets/img/jal-ro/palak-slide-2.jpg",
  },
  {
    title: "Commercial RO Plant Service",
    subtitle: "25 LPH, 50 LPH and 100 LPH commercial RO installation, repair and maintenance.",
    image: "/assets/img/jal-ro/palak-slide-3.jpg",
  },
  {
    title: "Genuine Filter and Membrane Replacement",
    subtitle: "Sediment, carbon, RO membrane, UV, UF, alkaline and mineral cartridges with proper TDS setting.",
    image: "/assets/img/jal-ro/palak-slide-4.jpg",
  },
  {
    title: "Annual RO AMC Plans",
    subtitle: "Prevent breakdowns, improve taste and keep your family safe with planned RO maintenance.",
    image: "/assets/img/jal-ro/palak-slide-5.jpg",
  },
  {
    title: "All Brand RO Service Support",
    subtitle: "Kent, Aquaguard, Livpure, Pureit, AO Smith, Blue Star, Aqua Fresh and more.",
    image: "/assets/img/jal-ro/ro-uv-uf-system.jpeg",
  },
];

export const locations = [
  "Delhi",
  "Noida",
  "Greater Noida",
  "Ghaziabad",
  "Faridabad",
  "Gurugram",
];

export const whyChooseUs = [
  "10+ Years Experience",
  "Expert Technicians",
  "Genuine Spare Parts",
  "Affordable Pricing",
  "Same Day Service",
  "Customer Satisfaction",
];

export const services = [
  "RO Installation",
  "RO Repair",
  "RO AMC Service",
  "RO Maintenance",
  "Filter Replacement",
  "Membrane Replacement",
  "UV Replacement",
  "TDS Adjustment",
  "Water Leakage Repair",
  "Domestic RO Service",
  "Commercial RO Service",
  "All Brand RO Service",
];

const commonServiceIncludes = [
  "Doorstep technician visit",
  "Water taste, smell and TDS check",
  "Leakage, flow and pressure inspection",
  "Transparent repair estimate",
  "Genuine parts on request",
  "Final water quality testing",
];

export const serviceDetails = [
  {
    slug: "ro-water-purifier-repair-service-delhi",
    title: "RO Water Purifier Repair Service in Delhi",
    shortTitle: "RO Repair",
    icon: "fas fa-tools",
    image: "/assets/img/jal-ro/service-tech.png",
    summary:
      "Quick repair for RO purifier not working, low water flow, bad taste, leakage, pump noise, auto cut issue and TDS problem.",
    details:
      "Jal RO System provides professional RO water purifier repair service across Delhi NCR. Our technician checks every important part including pre-filter, sediment filter, carbon filter, RO membrane, pump, SMPS, float valve, UV lamp, pipe connection and storage tank before recommending the right repair.",
    problems: [
      "RO purifier not starting",
      "Water leakage from machine or pipe",
      "Low water flow or empty tank",
      "Bad smell or salty water taste",
      "High or very low TDS reading",
      "Pump noise, auto cut fault or continuous drain water",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["Do you provide same day RO repair?", "Yes, same day service is available in most Delhi NCR locations."],
      ["Can you repair all brands?", "Yes, we service most domestic and commercial RO brands."],
      ["Will you check TDS after repair?", "Yes, final TDS and water taste check is included."],
    ],
  },
  {
    slug: "ro-installation-service-delhi",
    title: "RO Installation Service in Delhi NCR",
    shortTitle: "RO Installation",
    icon: "fas fa-tools",
    image: "/assets/img/jal-ro/palak-slide-2.jpg",
    summary: "Clean wall mount or under-sink RO installation with pipe fitting, leakage testing and TDS setup.",
    details:
      "Book RO installation for new or shifted water purifiers. We handle inlet connection, drain connection, tap fitting, tank setup, filter flushing and complete water quality verification.",
    problems: [
      "New RO installation",
      "RO shifting and re-installation",
      "Wall mount fitting",
      "Under-sink RO setup",
      "Tap and pipe connection",
      "Initial flushing and TDS check",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["How long does RO installation take?", "Most domestic RO installations are completed in 45 to 90 minutes."],
      ["Do I need to arrange pipes?", "Basic fitting material can be arranged by our technician if required."],
      ["Can you install commercial RO?", "Yes, we install domestic and commercial RO systems."],
    ],
  },
  {
    slug: "ro-amc-service-delhi",
    title: "RO AMC Service in Delhi NCR",
    shortTitle: "RO AMC Service",
    icon: "fas fa-calendar-check",
    image: "/assets/img/jal-ro/palak-slide-5.jpg",
    summary: "Annual maintenance plans for regular filter checks, breakdown support and safe drinking water.",
    details:
      "Our RO AMC plans are designed for families, offices and commercial spaces that want reliable water purifier maintenance without repeated follow-up. Plans can include scheduled visits, filter reminders, TDS check, leakage check and priority service.",
    problems: [
      "Regular maintenance visits",
      "Filter replacement reminder",
      "Emergency breakdown support",
      "Water quality monitoring",
      "Leakage and flow inspection",
      "Family and office AMC plans",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["Why should I take RO AMC?", "AMC helps prevent sudden breakdowns and keeps water quality stable."],
      ["Do AMC plans include parts?", "Part inclusion depends on the selected plan and will be confirmed before booking."],
      ["Is AMC available for offices?", "Yes, we provide AMC for homes, offices and commercial locations."],
    ],
  },
  {
    slug: "ro-maintenance-service-delhi",
    title: "RO Maintenance Service in Delhi NCR",
    shortTitle: "RO Maintenance",
    icon: "fas fa-shield-alt",
    image: "/assets/img/jal-ro/filter-part-1.png",
    summary: "Periodic service to clean, inspect and tune your RO purifier for better water taste and performance.",
    details:
      "RO maintenance includes checking filters, membrane performance, TDS level, tank hygiene, pipe condition, leakage points and electrical parts. Regular maintenance increases purifier life and helps avoid unsafe drinking water.",
    problems: [
      "Bad water taste",
      "Slow filling tank",
      "Dirty pre-filter",
      "Irregular TDS level",
      "Water wastage issue",
      "Annual health checkup",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["How often should RO be serviced?", "For most homes, service every 3 to 6 months is recommended."],
      ["Do you clean the RO tank?", "Tank hygiene is checked and cleaning is advised when needed."],
      ["Is maintenance different from repair?", "Maintenance is preventive, while repair fixes an existing fault."],
    ],
  },
  {
    slug: "ro-filter-replacement-service-delhi",
    title: "RO Filter Replacement Service in Delhi NCR",
    shortTitle: "Filter Replacement",
    icon: "fas fa-filter",
    image: "/assets/img/jal-ro/filter-part-2.png",
    summary: "Sediment, carbon, pre-filter, post-carbon, mineral and alkaline filter replacement.",
    details:
      "Old filters can affect taste, smell and water safety. Our technicians replace required filters, flush the system and check TDS and water flow after replacement.",
    problems: [
      "Bad smell in water",
      "Yellow or unclear water",
      "Filter choking",
      "Low water flow",
      "Expired filters",
      "Taste improvement",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["When should filters be replaced?", "Usually every 6 to 12 months depending on water quality and usage."],
      ["Do you provide genuine filters?", "Yes, genuine and compatible filter options are available."],
      ["Will water taste improve?", "In most cases, filter replacement improves taste and smell."],
    ],
  },
  {
    slug: "ro-membrane-replacement-service-delhi",
    title: "RO Membrane Replacement Service in Delhi NCR",
    shortTitle: "Membrane Replacement",
    icon: "fas fa-water",
    image: "/assets/img/jal-ro/domestic-ro-black.jpeg",
    summary: "RO membrane replacement for high TDS, salty taste, low purification and low output problems.",
    details:
      "The RO membrane is the heart of a purifier. If TDS is not reducing, water tastes salty or the tank fills very slowly, membrane inspection and replacement may be required.",
    problems: [
      "High TDS after purification",
      "Salty or hard water taste",
      "Tank not filling properly",
      "Low water output",
      "Continuous drain water",
      "Membrane choking",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["How long does an RO membrane last?", "Usually 1 to 2 years, depending on input water quality and usage."],
      ["Do you set TDS after membrane change?", "Yes, TDS setting and final testing are included."],
      ["Can membrane be cleaned?", "Sometimes flushing helps, but damaged or exhausted membranes need replacement."],
    ],
  },
  {
    slug: "uv-replacement-service-delhi",
    title: "UV Replacement Service in Delhi NCR",
    shortTitle: "UV Replacement",
    icon: "fas fa-lightbulb",
    image: "/assets/img/jal-ro/ro-uv-uf-system.jpeg",
    summary: "UV lamp, UV chamber and electrical checking for RO + UV water purifiers.",
    details:
      "UV purification supports water safety by neutralizing microorganisms. We check UV lamp condition, chamber, wiring, connector and purifier warning indicators before replacement.",
    problems: [
      "UV lamp not working",
      "UV indicator warning",
      "Electrical fault",
      "Low purification confidence",
      "Old UV lamp",
      "RO + UV system servicing",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["When should UV lamp be changed?", "Usually once a year or when the system shows UV fault."],
      ["Can I use RO if UV is faulty?", "It is better to repair UV quickly for complete purification."],
      ["Do you check wiring?", "Yes, UV electrical connections are checked before replacement."],
    ],
  },
  {
    slug: "tds-adjustment-service-delhi",
    title: "TDS Adjustment Service in Delhi NCR",
    shortTitle: "TDS Adjustment",
    icon: "fas fa-tachometer-alt",
    image: "/assets/img/jal-ro/mineral-ro-system.jpeg",
    summary: "TDS controller setting for balanced taste, mineral level and safe drinking water.",
    details:
      "If water tastes too flat, salty or bitter, TDS adjustment may be needed. Our technician checks input and output TDS, membrane performance and mineral cartridge condition before setting the right level.",
    problems: [
      "Very low TDS water",
      "Salty taste after service",
      "Bitter or flat taste",
      "Mineral cartridge setting",
      "TDS controller issue",
      "Post-service water testing",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["What is ideal TDS?", "Ideal TDS depends on water source and taste preference; our technician will test and guide."],
      ["Can TDS be adjusted in every RO?", "Most systems with a TDS controller can be adjusted."],
      ["Do you provide TDS meter testing?", "Yes, TDS is checked during service."],
    ],
  },
  {
    slug: "water-leakage-repair-service-delhi",
    title: "RO Water Leakage Repair Service in Delhi NCR",
    shortTitle: "Water Leakage Repair",
    icon: "fas fa-tint",
    image: "/assets/img/jal-ro/palak-slide-4.jpg",
    summary: "Leakage repair for pipe, connector, tap, tank, filter housing and purifier body.",
    details:
      "Water leakage can damage cabinets, walls and electrical parts. We identify the leakage point and repair or replace faulty pipes, elbows, connectors, tap, tank valve or filter housing.",
    problems: [
      "Leakage from RO body",
      "Pipe or connector leakage",
      "Tap leakage",
      "Tank overflow",
      "Filter housing crack",
      "Drain water leakage",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["Is RO leakage urgent?", "Yes, leakage should be fixed quickly to avoid damage and electrical risk."],
      ["Do you carry connectors and pipes?", "Common connectors and pipes are usually available with the technician."],
      ["Can leakage happen after filter change?", "Yes, loose fitting or old O-rings can cause leakage."],
    ],
  },
  {
    slug: "domestic-ro-service-delhi",
    title: "Domestic RO Service in Delhi NCR",
    shortTitle: "Domestic RO Service",
    icon: "fas fa-home",
    image: "/assets/img/jal-ro/alkaline-ro-system.jpeg",
    summary: "Home RO service for families, apartments, builder floors and residential societies.",
    details:
      "We provide complete domestic RO service including installation, repair, maintenance, filter change, membrane replacement, leakage repair, TDS adjustment and annual service plans.",
    problems: [
      "Home purifier repair",
      "Family RO maintenance",
      "Kitchen RO installation",
      "Apartment service visit",
      "Water taste issue",
      "Low flow issue",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["Do you service apartments?", "Yes, we cover apartments, societies and individual homes."],
      ["Can I book service on WhatsApp?", "Yes, WhatsApp booking is available."],
      ["Do you provide same day home service?", "Yes, same day slots are available in most areas."],
    ],
  },
  {
    slug: "commercial-ro-service-delhi",
    title: "Commercial RO Service in Delhi NCR",
    shortTitle: "Commercial RO Service",
    icon: "fas fa-industry",
    image: "/assets/img/jal-ro/commercial-ro-plant.jpeg",
    summary: "Commercial RO plant installation, repair and AMC for offices, restaurants, shops and factories.",
    details:
      "Commercial RO systems need regular care because usage is high. We service 25 LPH, 50 LPH, 100 LPH and customized commercial RO plants with pump, membrane, pre-treatment, flow and TDS checks.",
    problems: [
      "Commercial RO plant not working",
      "Low water production",
      "High TDS output",
      "Plant leakage",
      "Pump and pressure issue",
      "Office or restaurant AMC",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["Do you repair 100 LPH plants?", "Yes, we service 25 LPH, 50 LPH, 100 LPH and larger setups."],
      ["Can you provide AMC for restaurants?", "Yes, commercial AMC is available for restaurants and offices."],
      ["Do you install new plants?", "Yes, installation and commissioning support is available."],
    ],
  },
  {
    slug: "all-brand-ro-service-delhi",
    title: "All Brand RO Service in Delhi NCR",
    shortTitle: "All Brand RO Service",
    icon: "fas fa-medal",
    image: "/assets/img/jal-ro/palak-slide-1.jpg",
    summary: "Service support for Kent, Aquaguard, Livpure, Pureit, AO Smith, Blue Star, Aqua Fresh and more.",
    details:
      "Our technicians handle most popular domestic and commercial RO purifier brands. We diagnose brand-specific faults, arrange compatible parts and complete final water quality testing.",
    problems: [
      "Kent RO service",
      "Aquaguard RO repair",
      "Livpure service",
      "Pureit service",
      "AO Smith and Blue Star service",
      "Aqua Fresh and local brand service",
    ],
    includes: commonServiceIncludes,
    faqs: [
      ["Which RO brands do you service?", "We service most popular domestic and commercial RO brands."],
      ["Do you use original parts?", "Original and compatible parts are offered depending on availability and budget."],
      ["Can you service local brands?", "Yes, many local RO purifier models can be serviced."],
    ],
  },
];

export const serviceCards = serviceDetails.slice(0, 6).map((service) => ({
  title: service.shortTitle,
  text: service.summary,
  icon: service.icon,
  slug: service.slug,
}));

export const products = [
  {
    slug: "domestic-ro-water-purifier",
    title: "Domestic RO Water Purifier",
    price: "Rs. 8,999",
    text: "Compact purifier for homes with multi-stage filtration and fresh-tasting drinking water.",
    image: "/assets/img/jal-ro/domestic-ro-black.jpeg",
    gallery: ["/assets/img/jal-ro/domestic-ro-black.jpeg", "/assets/img/jal-ro/ultra-detail.webp"],
    overview:
      "Domestic RO Water Purifier is designed for families that want clean, safe and better-tasting drinking water every day. It combines RO filtration with optional UV, UF, mineral and TDS control support to handle Delhi NCR water conditions.",
    features: [
      "Multi-stage purification for borewell, tanker and municipal water",
      "RO membrane support for high TDS water",
      "UV and UF support for extra protection",
      "TDS controller for balanced taste",
      "Mineral cartridge option",
      "Elegant wall-mounted cabinet",
      "Suitable for homes, apartments and small offices",
      "Easy service access for filter and membrane replacement",
    ],
    specifications: [
      ["Purification", "RO + UV + UF + TDS controller options"],
      ["Storage", "Approx. 8 to 12 litre domestic storage cabinet"],
      ["Usage", "Family drinking water and kitchen use"],
      ["Suitable Water", "Municipal, tanker and borewell water after testing"],
      ["Service Support", "Installation, repair, AMC and spare parts"],
      ["Warranty", "As per selected model and parts"],
    ],
    applications: ["Home kitchen", "Apartment", "Builder floor", "Small office", "Clinic", "Retail shop"],
  },
  {
    slug: "ro-uv-uf-system",
    title: "RO + UV + UF Systems",
    price: "Rs. 11,499",
    text: "Advanced purification with RO, UV, UF, alkaline, mineral, and TDS controller options.",
    image: "/assets/img/jal-ro/ro-uv-uf-system.jpeg",
    gallery: ["/assets/img/jal-ro/ro-uv-uf-system.jpeg"],
    overview:
      "RO + UV + UF systems provide layered purification for customers who want strong protection and stable water taste.",
    features: ["RO membrane purification", "UV lamp support", "UF filtration", "TDS adjustment", "Mineral cartridge support"],
    specifications: [["Purification", "RO + UV + UF"], ["Use", "Domestic and small office"], ["Service", "Doorstep support"]],
    applications: ["Homes", "Offices", "Clinics", "Shops"],
  },
  {
    slug: "alkaline-ro-system",
    title: "Alkaline RO Systems",
    price: "Rs. 12,999",
    text: "Balanced mineral water systems designed for better taste and daily family use.",
    image: "/assets/img/jal-ro/alkaline-ro-system.jpeg",
    gallery: ["/assets/img/jal-ro/alkaline-ro-system.jpeg"],
    overview:
      "Alkaline RO systems add taste balancing and mineral support after RO purification for smooth daily drinking water.",
    features: ["Alkaline cartridge option", "Mineral balancing", "RO purification", "Better taste support"],
    specifications: [["Purification", "RO + alkaline option"], ["Use", "Home and office"], ["Service", "Filter and cartridge replacement"]],
    applications: ["Families", "Health-focused users", "Offices"],
  },
  {
    slug: "mineral-ro-system",
    title: "Mineral RO Systems",
    price: "Rs. 10,999",
    text: "RO systems with mineral cartridge support for clean water with essential minerals.",
    image: "/assets/img/jal-ro/mineral-ro-system.jpeg",
    gallery: ["/assets/img/jal-ro/mineral-ro-system.jpeg"],
    overview:
      "Mineral RO systems are suitable when you want purified water with controlled mineral taste and regular service support.",
    features: ["Mineral cartridge", "TDS controller", "RO membrane", "Taste improvement"],
    specifications: [["Purification", "RO + mineral support"], ["Use", "Domestic"], ["Service", "AMC available"]],
    applications: ["Homes", "Apartments", "Small offices"],
  },
  {
    slug: "commercial-ro-plants",
    title: "Commercial RO Plants",
    price: "Rs. 34,999",
    text: "Reliable commercial solutions for offices, shops, restaurants, schools, and factories.",
    image: "/assets/img/jal-ro/commercial-ro-plant.jpeg",
    gallery: ["/assets/img/jal-ro/commercial-ro-plant.jpeg"],
    overview:
      "Commercial RO plants are built for high daily water usage with proper pre-treatment, pump pressure and membrane performance.",
    features: ["High output capacity", "Commercial pump support", "Multi-stage filtration", "AMC support"],
    specifications: [["Capacity", "Custom as per requirement"], ["Use", "Commercial"], ["Service", "Installation and maintenance"]],
    applications: ["Offices", "Restaurants", "Schools", "Factories"],
  },
  {
    slug: "25-50-100-lph-commercial-ro",
    title: "25, 50 & 100 LPH Commercial RO",
    price: "Rs. 45,000",
    text: "High-capacity commercial RO plants with installation, service, and maintenance support.",
    image: "/assets/img/jal-ro/commercial-100-lph.jpeg",
    gallery: ["/assets/img/jal-ro/commercial-100-lph.jpeg"],
    overview:
      "25 LPH, 50 LPH and 100 LPH RO plants are ideal for small to medium commercial water demand.",
    features: ["25 LPH, 50 LPH and 100 LPH options", "TDS check", "Pump and pressure inspection", "AMC available"],
    specifications: [["Capacity", "25 LPH / 50 LPH / 100 LPH"], ["Use", "Commercial"], ["Support", "Repair, AMC and installation"]],
    applications: ["Restaurants", "Offices", "Canteens", "Shops"],
  },
  {
    slug: "under-sink-ro-water-purifier",
    title: "Under Sink RO Water Purifier",
    price: "Rs. 15,999",
    text: "Space-saving under-counter RO purifier for modular kitchens and premium homes.",
    image: "/assets/img/jal-ro/ro-uv-uf-system.jpeg",
    gallery: ["/assets/img/jal-ro/ro-uv-uf-system.jpeg"],
    overview:
      "Under sink RO systems keep the purifier hidden under the counter while delivering purified drinking water through a separate faucet.",
    features: ["Hidden installation", "Separate drinking water tap", "RO + TDS support", "Ideal for modular kitchens"],
    specifications: [["Purification", "RO + TDS options"], ["Use", "Domestic premium kitchen"], ["Service", "Installation and AMC"]],
    applications: ["Modular kitchens", "Premium homes", "Apartments"],
  },
  {
    slug: "hot-cold-ro-water-dispenser",
    title: "Hot & Cold RO Water Dispenser",
    price: "Rs. 22,500",
    text: "RO water dispenser solution for offices, clinics, shops and reception areas.",
    image: "/assets/img/jal-ro/commercial-100-lph.jpeg",
    gallery: ["/assets/img/jal-ro/commercial-100-lph.jpeg"],
    overview:
      "Hot and cold RO dispenser setups are suitable for workplaces that need clean drinking water with easy dispensing.",
    features: ["Hot and cold dispensing", "RO compatible", "Office friendly", "Easy maintenance"],
    specifications: [["Type", "RO dispenser setup"], ["Use", "Office and commercial"], ["Service", "Repair and maintenance"]],
    applications: ["Offices", "Clinics", "Shops", "Reception areas"],
  },
  {
    slug: "water-softener-system",
    title: "Water Softener System",
    price: "Rs. 28,000",
    text: "Hard water softener for homes, bathrooms, washing machines and commercial use.",
    image: "/assets/img/jal-ro/palak-slide-3.jpg",
    gallery: ["/assets/img/jal-ro/palak-slide-3.jpg"],
    overview:
      "Water softener systems help reduce hardness scale in bathrooms, geysers, washing machines and plumbing lines.",
    features: ["Hardness reduction", "Better appliance life", "Manual and automatic options", "Home and commercial use"],
    specifications: [["Type", "Water softener"], ["Use", "Home and commercial"], ["Service", "Installation and maintenance"]],
    applications: ["Homes", "Bathrooms", "Geysers", "Laundry", "Commercial spaces"],
  },
  {
    slug: "industrial-ro-plant",
    title: "Industrial RO Plant",
    price: "Rs. 85,000",
    text: "Industrial RO setup for high-volume water purification requirements.",
    image: "/assets/img/jal-ro/commercial-ro-plant.jpeg",
    gallery: ["/assets/img/jal-ro/commercial-ro-plant.jpeg"],
    overview:
      "Industrial RO plants are designed for high water demand with proper pre-treatment, pump pressure, flow monitoring and membrane performance.",
    features: ["High capacity output", "Pre-treatment support", "Commercial pump system", "AMC and service support"],
    specifications: [["Capacity", "Custom capacity"], ["Use", "Industrial and commercial"], ["Service", "Installation, repair and AMC"]],
    applications: ["Factories", "Plants", "Schools", "Hospitals", "Commercial kitchens"],
  },
];

export const processSteps = [
  { title: "Book Service", text: "Call, WhatsApp or submit the enquiry form with your RO issue." },
  { title: "Technician Visit", text: "An expert checks filters, membrane, pump, UV, leakage and TDS." },
  { title: "Clear Estimate", text: "You get transparent pricing before repair or part replacement." },
  { title: "Clean Water Ready", text: "Final water quality, leakage and flow tests are completed." },
];

export const reviews = [
  {
    name: "Rohit Sharma",
    location: "Noida",
    text: "Same day RO repair ho gaya. Technician ne TDS bhi set karke water taste improve kar diya.",
  },
  {
    name: "Neha Gupta",
    location: "Delhi",
    text: "Genuine filters and clear pricing. Jal RO System ka AMC service kaafi reliable hai.",
  },
  {
    name: "Amit Yadav",
    location: "Gurugram",
    text: "Commercial RO plant service time par hui aur leakage problem completely solve ho gayi.",
  },
];

export const faqItems = [
  ["Do you provide same day RO service?", "Yes, same day RO service is available in most Delhi NCR areas depending on slot availability."],
  ["Which RO brands do you repair?", "We service most popular brands including Kent, Aquaguard, Livpure, Pureit, AO Smith, Blue Star, Aqua Fresh and many local brands."],
  ["How can I book a service?", "You can call, WhatsApp, or submit the enquiry form. Our team will contact you for confirmation."],
  ["Do you provide RO AMC?", "Yes, we provide AMC plans for homes, offices and commercial RO plants."],
  ["Do you replace filters and membranes?", "Yes, sediment filter, carbon filter, RO membrane, UV, UF, mineral and alkaline parts are available."],
  ["Will the form enquiry come to email?", "Yes, the website includes a PHP enquiry handler configured for info@jalro.in on PHP hosting."],
  ["Do you cover Gurugram and Noida?", "Yes, we cover Delhi, Noida, Greater Noida, Ghaziabad, Faridabad and Gurugram."],
];

export const careerOpenings = [
  {
    title: "RO Service Technician",
    type: "Full Time",
    location: "Delhi NCR",
    text: "Experienced technician for domestic RO repair, installation, filter replacement and customer visits.",
  },
  {
    title: "Commercial RO Technician",
    type: "Full Time",
    location: "Delhi NCR",
    text: "Technician with knowledge of 25 LPH, 50 LPH, 100 LPH commercial RO plant service and maintenance.",
  },
  {
    title: "Customer Support Executive",
    type: "Full Time",
    location: "Delhi NCR",
    text: "Handle calls, WhatsApp enquiries, service bookings and customer follow-ups.",
  },
];
